import { render } from "./operatorControls.vue?vue&type=template&id=5634a477"
import script from "./operatorControls.vue?vue&type=script&lang=js"
export * from "./operatorControls.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__